import React, { useEffect, useState } from "react";

import { useLocation } from "react-router-dom"; // Import useLocation to get the current path
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import {
  Routes,
  Route,
  Navigate } from
"react-router-dom";

import { useAuth, Roles } from "./providers/AuthContext";
import { useTranslation } from "react-i18next";

import ExternalUsersPage from "./pages/externalUsers/ExternalUsersPage";
import CreateExternalUserPage from "./pages/externalUsers/CreateExternalUserPage";
import EditExternalUserPage from "./pages/externalUsers/EditExternalUserPage";


//Partners
import PartnersPage from "./pages/partners/PartnersPage";
import InvoicesPage from "./pages/invoices/InvoicesPage";
import InvoiceDetailPage from "./pages/invoices/InvoiceDetailPage";
import CreatePartnerPage from "./pages/partners/CreatePartnerPage";
import EditPartnerPage from "./pages/partners/EditPartnerPage";

import OrganizationsPage from "./pages/organizations/OrganizationsPage";
import EditOrganizationPage from "./pages/organizations/EditOrganizationPage";
import CreateOrganizationPage from "./pages/organizations/CreateOrganizationPage";

//Customer
import CustomersPage from "./pages/customer/CustomersPage";
import EditCustomerPage from "./pages/customer/EditCustomerPage";
import CreateCustomerPage from "./pages/customer/CreateCustomerPage";

//Sites
import SitesPage from "./pages/site/SitesPage";
import CreateSitePage from "./pages/site/CreateSitePage";
import EditSitePage from "./pages/site/EditSitePage";


//Connector
import PointsPage from "./pages/point/PointsPage";
import CreatePointPage from "./pages/point/CreatePointPage";
import EditPointPage from "./pages/point/EditPointPage";

//Connector
import ConnectorsPage from "./pages/connector/ConnectorsPage";
import CreateConnectorPage from "./pages/connector/CreateConnectorPage";
import EditConnectorPage from "./pages/connector/EditConnectorPage";

//Discounts
import DiscountsPage from "./pages/discounts/DiscountsPage";
import CreateDiscountPage from "./pages/discounts/CreateDiscountPage";
import EditDiscountPage from "./pages/discounts/EditDiscountPage";

//Tokens
import TokensPage from "./pages/token/TokensPage";
import CreateTokenPage from "./pages/token/CreateTokenPage";
import EditTokenPage from "./pages/token/EditTokenPage";

//Manufacturer
import ManufacturersPage from "./pages/manufacturer/ManufacturersPage";
import CreateManufacturerPage from "./pages/manufacturer/CreateManufacturerPage";
import EditManufacturerPage from "./pages/manufacturer/EditManufacturerPage";

//Access Groups
import AccessGroupsPage from "./pages/accessGroups/AccessGroupsPage";
import CreateAccessGroupsPage from "./pages/accessGroups/CreateAccessGroupsPage";
import EditAccessGroupsPage from "./pages/accessGroups/EditAccessGroupsPage";

//OCPI Parties
import OcpiPartiesPage from "./pages/ocpiParties/OcpiPartiesPage";
import CreateOcpiPartyPage from "./pages/ocpiParties/CreateOcpiPartyPage";
import HandshakeOcpiPartyPage from "./pages/ocpiParties/HandshakeOcpiPartyPage";
import EditOcpiPartyPage from "./pages/ocpiParties/EditOcpiPartyPage";

import SystemsPage from "./pages/SystemsPage";
import TariffsPage from "./pages/tariffs/TariffsPage";
import CreateTariffPage from "./pages/tariffs/CreateTariffPage";
import EditTariffWizardPage from "./pages/tariffs/EditTariffWizardPage";

import LoginPage from "./pages/LoginPage";
import SessionsPage from "./pages/SessionsPage";
import LogsPage from "./pages/LogsPage";
import ConfigurationsPage from "./pages/configurations/ConfigurationsPage";

import SiteStatisticsDashboard from "./pages/siteStatistics/SiteStatisticsDashboard";
import CustomerStatisticsPage from "./pages/customerStatistics/CustomerStatisticsPage";
import BookingPage from "./pages/booking/BookingPage";
import GridAreasPage from "./pages/gridCost/GridAreasPage";
import CreateGridAreaPage from "./pages/gridCost/CreateGridAreaPage";
import EditGridAreaPage from "./pages/gridCost/EditGridAreaPage";
import GridCalculationsPage from "./pages/gridCost/GridCalculationsPage";
import ForecastFollowUpPage from "./pages/gridCost/ForecastFollowUpPage";
import AgentPage from "./pages/agent/AgentPage";
import AppPushPage from "./pages/appPush/AppPushPage";
import AppPushDetailPage from "./pages/appPush/AppPushDetailPage";

import { SidebarProvider } from "./providers/SidebarContext";
import { ChargeMonitor } from "./pages/chargeMonitor/ChargeMonitor";
import TermsAcceptanceGate from "./components/TermsAcceptanceGate";

function App() {
  const { loading } = useAuth();

  if (loading) {
    return <div></div>;
  }

  return (
    <SidebarProvider>
      <TermsAcceptanceGate>
          <Routes>

              <Route
            path="/chargeMonitor"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CustomerService, Roles.Partner, Roles.ServicePartner, Roles.CpmsLight]}>
                          <ChargeMonitor></ChargeMonitor>
                      </ProtectedRoute>} />


        <Route
            path="/"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CustomerService, Roles.Partner, Roles.Customer, Roles.ServicePartner, Roles.CpmsLight]}>
              <HomeRoute />
            </ProtectedRoute>} />


        <Route
            path="/logs"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <LogsPage />
            </ProtectedRoute>} />

        <Route
            path="/app-push"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CustomerService]}>
              <AppPushPage />
            </ProtectedRoute>} />

        <Route
            path="/app-push/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CustomerService]}>
              <AppPushDetailPage />
            </ProtectedRoute>} />



              {/* ExternalUsers */}
              <Route
            path="/externalUsers"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
                          <ExternalUsersPage />
                      </ProtectedRoute>} />


              <Route
            path="/externalUser/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
                          <EditExternalUserPage />
                      </ProtectedRoute>} />


              <Route
            path="/externalUser/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
                          <CreateExternalUserPage />
                      </ProtectedRoute>} />



        {/* Token */}
        <Route
            path="/tokens"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <TokensPage />
            </ProtectedRoute>} />


        <Route
            path="/token/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditTokenPage />
            </ProtectedRoute>} />


        <Route
            path="/token/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateTokenPage />
            </ProtectedRoute>} />



        {/* Manufacturer */}
        <Route
            path="/manufacturers"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <ManufacturersPage />
            </ProtectedRoute>} />


        <Route
            path="/manufacturer/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <EditManufacturerPage />
            </ProtectedRoute>} />


        <Route
            path="/manufacturer/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <CreateManufacturerPage />
            </ProtectedRoute>} />



        {/* Access Groups */}
        <Route
            path="/accessgroups"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <AccessGroupsPage />
            </ProtectedRoute>} />


        <Route
            path="/accessgroup/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditAccessGroupsPage />
            </ProtectedRoute>} />


        <Route
            path="/accessgroup/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateAccessGroupsPage />
            </ProtectedRoute>} />



        <Route
            path="/invoices"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <InvoicesPage />
            </ProtectedRoute>} />

        <Route
            path="/invoices/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <InvoiceDetailPage />
            </ProtectedRoute>} />

        {/* Partners */}
        <Route
            path="/partners"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <PartnersPage />
            </ProtectedRoute>} />


        <Route
            path="/partner/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <EditPartnerPage />
            </ProtectedRoute>} />


        <Route
            path="/partner/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <CreatePartnerPage />
            </ProtectedRoute>} />


              {/* Organizations */}
              <Route
            path="/organizations"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
                          <OrganizationsPage />
                      </ProtectedRoute>} />



              <Route
            path="/organization/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
                          <EditOrganizationPage />
                      </ProtectedRoute>} />



              <Route
            path="/organization/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
                          <CreateOrganizationPage />
                      </ProtectedRoute>} />




        {/* CUSTOMERS */}
        <Route
            path="/customers"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CustomersPage />
            </ProtectedRoute>} />


        <Route
            path="/customer/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditCustomerPage />
            </ProtectedRoute>} />


        <Route
            path="/customer/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateCustomerPage />
            </ProtectedRoute>} />



        {/* SITE */}
        <Route
            path="/sites"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <SitesPage />
            </ProtectedRoute>} />


        <Route
            path="/site/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditSitePage />
            </ProtectedRoute>} />


        <Route
            path="/site/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateSitePage />
            </ProtectedRoute>} />



        {/* Point */}
        <Route
            path="/points"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <PointsPage />
            </ProtectedRoute>} />


        <Route
            path="/point/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditPointPage />
            </ProtectedRoute>} />


        <Route
            path="/point/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreatePointPage />
            </ProtectedRoute>} />



        {/* Connector */}
        <Route
            path="/connectors"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <ConnectorsPage />
            </ProtectedRoute>} />


        <Route
            path="/connector/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditConnectorPage />
            </ProtectedRoute>} />


        <Route
            path="/connector/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateConnectorPage />
            </ProtectedRoute>} />


        <Route
            path="/booking"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.Customer]}>
              <BookingPage />
            </ProtectedRoute>} />



        {/*Discounts*/}
        <Route
            path="/discounts"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <DiscountsPage />
            </ProtectedRoute>} />


        <Route
            path="/discount/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <CreateDiscountPage />
            </ProtectedRoute>} />


        <Route
            path="/discount/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <EditDiscountPage />
            </ProtectedRoute>} />


        {/* Tariffs */}
        <Route
            path="/tariffs"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <TariffsPage />
            </ProtectedRoute>} />


        <Route
            path="/tariffs/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateTariffPage />
            </ProtectedRoute>} />


        <Route
            path="/tariffs/:id/edit"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditTariffWizardPage />
            </ProtectedRoute>} />


        <Route
            path="/tariffs/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditTariffWizardPage />
            </ProtectedRoute>} />


        <Route
            path="/sessions"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <SessionsPage />
            </ProtectedRoute>} />


        <Route
            path="/systems"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <SystemsPage />
            </ProtectedRoute>} />



        <Route
            path="/ocpi-parties"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <OcpiPartiesPage />
            </ProtectedRoute>} />


        <Route
            path="/ocpi-party/handshake"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <HandshakeOcpiPartyPage />
            </ProtectedRoute>} />


        <Route
            path="/ocpi-party/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <CreateOcpiPartyPage />
            </ProtectedRoute>} />


        <Route
            path="/ocpi-party/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <EditOcpiPartyPage />
            </ProtectedRoute>} />



         <Route
            path="/configurations"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <ConfigurationsPage />
            </ProtectedRoute>} />



              <Route
            path="/SiteStatisticsDashboard"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.Partner, Roles.CpmsLight, Roles.Partner]}>
                          <SiteStatisticsDashboard />
                      </ProtectedRoute>} />

        <Route
            path="/customer-statistics"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CustomerStatisticsPage />
            </ProtectedRoute>} />

        <Route
            path="/grid-areas"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <GridAreasPage />
            </ProtectedRoute>} />

        <Route
            path="/grid-areas/create"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <CreateGridAreaPage />
            </ProtectedRoute>} />

        <Route
            path="/grid-areas/:id"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <EditGridAreaPage />
            </ProtectedRoute>} />

        <Route
            path="/grid-calculations"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin, Roles.CpmsLight]}>
              <GridCalculationsPage />
            </ProtectedRoute>} />

        <Route
            path="/forecast-follow-up"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <ForecastFollowUpPage />
            </ProtectedRoute>} />

        <Route
            path="/agent"
            element={
            <ProtectedRoute requiredRoles={[Roles.Admin]}>
              <AgentPage />
            </ProtectedRoute>} />



        <Route path="/login" element={<LoginPage />} />
      </Routes>
      </TermsAcceptanceGate>
    </SidebarProvider>);

}

export default App;

const HomeRoute = () => {
  const { hasRole } = useAuth();

  if (hasRole(Roles.ServicePartner)) {
    return <Navigate to="/chargeMonitor" replace />;
  }

  return <SessionsPage />;
};

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { isAuthenticated, hasAnyRole, rolesLoading, login } = useAuth();
  const { instance, accounts, inProgress } = useMsal();
  const location = useLocation();

  const [checkingSession, setCheckingSession] = useState(true);

  // Spara redirect path
  useEffect(() => {
    if (!isAuthenticated) {
      sessionStorage.setItem("redirectPath", location.pathname);
    }
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    const validateSession = async () => {
      try {
        // Om inget konto finns → ej inloggad
        if (!accounts || accounts.length === 0) {
          login();
          return;
        }

        // Försök silent token refresh
        await instance.acquireTokenSilent({
          account: accounts[0],
          scopes: ["User.Read"] // använd samma scopes som du använder i appen
        });

        setCheckingSession(false);
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          // Session expired → tvinga login
          login();
        } else {
          console.error("Token validation error:", error);
          login();
        }
      }
    };

    if (inProgress === "none") {
      validateSession();
    }
  }, [instance, accounts, inProgress, login]);

  // Vänta på MSAL + roll-laddning
  if (inProgress !== "none" || rolesLoading || checkingSession) {
    return null;
  }

  // Om inte autentiserad → login triggas redan
  if (!isAuthenticated) {
    return null;
  }

  // Inloggad men saknar roll → riktig 403
  if (requiredRoles.length && !hasAnyRole(requiredRoles)) {
    return <NotAuthorized />;
  }

  return children;
};

const NotAuthorized = () => {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <h2>{t("common.forbiddenTitle")}</h2>
      <p>{t("common.noPagePermission")}</p>
    </div>
  );
};